export default __webpack_public_path__ + "b32adc60256c371a87e08fe2487d893b.svg";